import {FC, useEffect, useState} from 'react'
import {BaseModal} from '../../BaseModal/BaseModal'
import {Input} from '../../../../components/Input/Input'
import {Button} from '../../../../components/Button/Button'
import styles from './createGrade.module.css'

type GridTypeResponse = {
  id: number
  name: string
  variation: string
  status?: boolean
  variationId?: number
}

type Props = {
  onCloseAction: () => void
  title: string
  grids: GridTypeResponse[]
  setGradeSelected: (grades: {variationId: number; variations: string[]}[]) => void
  gradeSelected: {variationId: number; variations: string[]}[]
}

const CreateGrade: FC<Props> = ({onCloseAction, title, grids, gradeSelected, setGradeSelected}) => {
  const [grades, setGrades] = useState<any[]>([])
  const [gradeListed, setGradeListed] = useState<any>()
  const [gradeVariation, setGradeVariation] = useState<any[]>([])
  const [selectedVariations, setSelectedVariations] = useState<Map<string, number>>(new Map())

  useEffect(() => {
    setGrades(
      grids
        .filter((grid) => !gradeSelected.some((grade) => grade.variationId === grid.id))
        .map((grid) => ({value: grid.id, select: grid.name}))
    )
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [grids])

  useEffect(() => {
    if (gradeListed?.value) {
      const variationsType = JSON.parse(
        grids.find((grid) => grid.id === gradeListed.value)?.variation || '[]'
      )

      if (Array.isArray(variationsType)) {
        setGradeVariation(variationsType.sort((a: any, b: any) => a.localeCompare(b)))
      } else if (typeof variationsType === 'object' && variationsType !== null) {
        setGradeVariation(
          Object.values(variationsType).sort((a: any, b: any) => a.localeCompare(b))
        )
      } else {
        setGradeVariation([])
      }
      setSelectedVariations(new Map())
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [gradeListed])

  const handleVariationClick = (variation: string) => {
    setSelectedVariations((prev) => {
      const newMap = new Map(prev)
      if (newMap.has(variation)) {
        newMap.delete(variation)
      } else {
        newMap.set(variation, gradeListed.value)
      }
      return newMap
    })
  }

  const handleSelectAll = () => {
    if (selectedVariations.size === gradeVariation.length) {
      setSelectedVariations(new Map())
    } else {
      const newMap = new Map()
      gradeVariation.forEach((variation) => {
        newMap.set(variation, gradeListed.value)
      })
      setSelectedVariations(newMap)
    }
  }

  return (
    <BaseModal
      onCloseAction={onCloseAction}
      title={title}
      disableClose={grades.length <= 0 ? true : false}
    >
      {grades.length > 0 ? (
        <div className={`${styles.modalContent}`}>
          <div className={styles.contentWrapper}>
            <div>
              <Input
                inputAttr={{
                  type: 'select',
                }}
                search
                label='Grades'
                options={grades}
                value={gradeListed}
                change={(value: string) => {
                  setGradeListed(value)
                }}
                marginTop='mt-0'
              />
            </div>
            {gradeVariation.length > 0 && (
              <div className='mt-6 pb-6'>
                <div
                  className={`d-flex align-items-center justify-content-between pb-3 ${styles.titleVariation}`}
                >
                  <h1 className='m-0 p-0 fs-5'>{gradeListed?.label}</h1>
                  <p className={`m-0 p-0 fs-8 ${styles.selectAll}`} onClick={handleSelectAll}>
                    {selectedVariations.size === gradeVariation.length
                      ? 'Deselecionar tudo'
                      : 'Selecionar tudo'}
                  </p>
                </div>
                <ul className={`m-0 p-0 list-unstyled ${styles.variationList}`}>
                  {gradeVariation.map((variation: any, index: number) => (
                    <li
                      key={index}
                      className={`${styles.variationItem} ${
                        selectedVariations.has(variation) ? styles.selected : ''
                      }`}
                      onClick={() => handleVariationClick(variation)}
                    >
                      <span>{variation}</span>
                      <input
                        type='checkbox'
                        checked={selectedVariations.has(variation)}
                        onChange={() => {}}
                      />
                    </li>
                  ))}
                </ul>
              </div>
            )}
          </div>
          <div className={`d-flex justify-content-end pt-6 ${styles.footer}`}>
            <Button
              text='Salvar'
              color='primary'
              size='small'
              horizontalPadding={5}
              btnAttr={{
                type: 'button',
              }}
              click={() => {
                const groupedVariations = Array.from(selectedVariations.entries()).reduce(
                  (acc, [variation, gradeId]) => {
                    if (!acc[gradeId]) {
                      acc[gradeId] = {
                        variationId: gradeId,
                        variations: [],
                      }
                    }
                    acc[gradeId].variations.push(variation)
                    return acc
                  },
                  {} as Record<number, {variationId: number; variations: string[]}>
                )

                const selectedGrades = Object.values(groupedVariations)
                setGradeSelected([...gradeSelected, ...selectedGrades])
                onCloseAction()
              }}
              disabled={selectedVariations.size === 0}
              btnClass='fw-bolder'
            />
          </div>
        </div>
      ) : (
        <div className='d-flex flex-column align-items-center justify-content-center p-6'>
          <p className='fs-6 text-muted mb-0'>Não há grades disponíveis para seleção</p>
        </div>
      )}
    </BaseModal>
  )
}

export {CreateGrade}
